import { render, staticRenderFns } from "./FoodList.vue?vue&type=template&id=3de21814&scoped=true&"
import script from "./FoodList.vue?vue&type=script&lang=js&"
export * from "./FoodList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3de21814",
  null
  
)

export default component.exports